
export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-pink-50 to-purple-50 py-8 mt-16">
      <div className="px-4">
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/309636e017ffa099c243a25008216468/7c4be6a727a4dcea9af2431be501e166.png" 
              alt="puluchu logo" 
              className="w-6 h-6"
            />
            <div className="text-2xl font-bold text-purple-600" style={{ fontFamily: 'Pacifico, serif' }}>
              puluchu
            </div>
          </div>
          
          <div className="space-y-2 text-sm text-gray-600">
            <p>茨城県北相馬郡利根町布川</p>
            <p>完全予約制プライベートサロン</p>
          </div>
          
          <div className="flex justify-center space-x-6">
            <a href="#" className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full hover:bg-pink-200 transition-colors">
              <i className="ri-instagram-line text-purple-600"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full hover:bg-pink-200 transition-colors">
              <i className="ri-line-fill text-purple-600"></i>
            </a>
          </div>
          
          <div className="text-xs text-gray-500 pt-4 border-t border-pink-200">
            © 2024 puluchu. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
